import { Avatar, Box, Divider, IconButton, InputBase, Paper, useTheme, Select, 
  MenuItem, Typography, } from '@mui/material'
import { Link, useNavigate } from 'react-router'
// import { useDispatch, useSelector } from 'react-redux'
// import { getCurrentUser} from '../../context/userSlice'
import axios from 'axios';
// import { tokens } from "../../theme";
import { useState, useEffect, useMemo, useCallback } from 'react'
// import UsersActions from '../../components/dataTable/UsersActions'
import DataTable from '../../components/dataTable/DataTables';
import SearchIcon from '@mui/icons-material/Search';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import Header from '../../components/Header';
// import Snackbars from '../../components/Snackbars';
// import Notistack from '../../components/Notistack';
import { useUserContext } from '../../contexts/UserContext';
import {  
  DataGrid,
  gridClasses,
  GridToolbar,
  GridColDef,
  GridToolbarQuickFilter,
  GridLogicOperator,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import Pagination from '@mui/material/Pagination';        
// import DataTableActions from '../../components/dataTable/DataTableActions';
import ProductsActions from '../../components/dataTable/ProductsActions';
import Add from '@mui/icons-material/Add';
import { blue, grey } from '@mui/material/colors';

const ProductsList = () => {
  const navigate = useNavigate();
  const user = useUserContext();

  const [query, setQuery] = useState([])
  const [data, setData] = useState([])
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [ filterData, setFilterData] = useState({});
  const [rowId, setRowId] = useState(null)
  // const [values, setValues] = useState({searchTxt: '',});
  const [searchTxt, setSearchTxt] = useState('')
  const keys = ['userName','uuser','cuser']
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState([])

  // const Conf = JSON.parse(localStorage.getItem("Conf"));
  // const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  // console.log(searchTxt)
  const apiurl = `${process.env.REACT_APP_API}/products.php`
  const imgurl = `${process.env.REACT_APP_URL}/image/products`
  const webpath = '/products'
  const [rowCountState, setRowCountState] = useState(
    data?.totalRecords || 0,
  );

  useEffect(() => {
    setRowCountState((prevRowCountState) => 
      data?.totalRecords !== undefined
        ? data?.totalRecords
        : prevRowCountState,
    );
  },[data?.totalRecords, setRowCountState]);

  // console.log(apiurl,imgurl);
  // console.log(rowCountState);

    // const handleChange = (prop) => (event) => {
    //   // setValues({ ...values, [prop]: event.target.value });
    //   setSearchTxt(event.target.value)
    // };

    const fetchCategory = async () => {
      try {
        const result = await axios.get(`${apiurl}?mode=getcategory`);
        
        // console.log(result);
        // console.log(result.data);
        // if(result.data.length>0) {
        if(result.data && result.data[0].length>0) {  
          // const data = await response.json();
          // console.log(result.data[0]);
          setCategory(result.data[0]);
          return result.data[0];
        }
  
      }
      catch(err) {
          console.log(err);
        }
      }
    
    useEffect(() => {
    
      fetchCategory();
      
    },[])

    // console.log(category)

    function handleClick ()  {
      // console.log("clicked on icon!",props.link);
      navigate(`/products/addnew`)
    }
  
    const handleClickClearSearchTxt = () => {
      // setValues({
      //   "searchTxt": ''
      // });
      // setQuery(values.searchTxt)
      setSearchTxt('')
    };
  
    const handleMouseDownSearchTxt = (event) => {
      event.preventDefault();
    };

    const columns  = useMemo(() => [
      { field: "id", 
        type: "number", 
        headerName: "ID", 
        headerAlign: 'center', 
        width: 60, 
      },
      {
        field: "img",
        headerName: "Image",
        renderCell:params=><Avatar variant="rounded" src={`${imgurl}/${params.row.img}`} />,
        sortable: false,
        filterable: false,
        headerAlign: 'center',
        width: 64,
        editable: false,
    
        // renderCell: (params) => {
        //   return <img src={`${process.env.REACT_APP_URL}/image/users/${params.row.Avatar} || '/user.png'`} alt="" />;
        // },
      },
      {
        field: "name",
        type: "string",
        headerName: "Name",
        width: 150,
        editable: true,
        flex:1, 
        minWidth: 100,
      },
      // {
      //   field: "lastName",
      //   type: "string",
      //   headerName: "Last name",
      //   width: 150,
      // },
      {
        field: "description",
        type: "string",
        headerName: "Description",
        width: 200,
        editable: true,
        flex:1,
        minWidth: 100, 
      },
      {
        field: "category",
        // type: "boolean",
        headerName: "Category",
        width: 100,
        headerAlign: 'center',
        type: 'string',
        // valueOptions: category.category,
        // getOptionValue: (value: any) => value,
        // getOptionLabel: (value: any) => value,
        // valueOptions: ['Bakery','Chiffon', 'Cake', ],
          // valueGetter: ({ value, GridColDef }) => {
          //   console.log(value,GridColDef);
          //   // const option = GridColDef.valueOptions.find(
          //   //   ({ value: optionValue }) => value === optionValue
          //   // );
          //   // return option.label;
          // },
        editable: true,
        flex: 0.5,
        minWidth: 100,
      },
      {
        field: "price",
        type: "number",
        headerName: "Price",
        // valueOptions: ['false', 'true'],
        // valueGetter: (value) => {
        //   return value==1? true:false;
        // },
        width: 100,
        editable: true,
        flex:0.3,
        minWidth: 90,
      },
      {
        field: "instock",
        type: "number",
        headerName: "InStock",
        // valueGetter: (value) => {
        //   return value==1? true:false;
        // },
        width: 100,
        editable:false,
        flex: 0.3,
        minWidth: 80,
      },
      {
        field: "recommend",
        type: "boolean",
        headerName: "Recommend",
        valueGetter: (value) => {
          return value==1? true:false;
        },
        width: 100,
        editable:true,
        flex: 0.3,
        minWidth:60,
      },
      {
        field: "promote",
        type: "boolean",
        headerName: "Promote",
        valueGetter: (value) => {
          return value==1? true:false;
        },
        width: 100,
        editable:true,
        flex: 0.3,
        minWidth:60,
      },
      {
        field: "active",
        type: "boolean",
        headerName: "Active",
        valueGetter: (value) => {
          return value==1? true:false;
        },
        width: 100,
        editable:true,
        flex: 0.3,
        minWidth:60,
      },
      {
          field: 'actions',
          headerName: 'Actions',
          type: 'actions',
          renderCell: params => <ProductsActions {...{params, rowId, setRowId, setData, webpath}} />,
          // headerClassName: 'datatable-header',
          headerAlign: 'center',
          width: 150,
          editable: false,
          // flex: 1,
      },

    ],[rowId]);

    const fetchProducts = async () => {
      try {
        const result = await axios.get(`${apiurl}?mode=list`);
        
        // console.log(result);
        // console.log(result.data);
        // if(result.data.length>0) {
        if(result.data && result.data[0].length>0) {  
          // const data = await response.json();
          // console.log(result.data[0]);
          setData(result.data[0]);
          return result.data[0];
        }

      }
      catch(err) {
          console.log(err);
        }
      }

  useEffect(() => {
    if(user?.user?.isAdmin < 1 ) {  // Role !== 'Admin'
      navigate("/")
    }}) 
    
  useEffect(() => {

        fetchProducts();
    
  },[])

  // useEffect(() => {
  //     setQuery(data)

  // },[data])

  // console.log(data);
    // console.log(query)
  const _s = 120 
  const [screenH, setScreenH] = useState(window.innerHeight-_s)

  // useEffect(() => {
  //     if (values.searchTxt.length === 0 || values.searchTxt.length > 2)
  //         setQuery(values.searchTxt)

  //     // console.log("searchTxt Change")

  // },[values.searchTxt])

  useEffect(() => {

    window.addEventListener('resize', setScreenH(window.innerHeight-_s));

    return () => {
      window.removeEventListener('resize', setScreenH(window.innerHeight-_s));
    };

    
  }, [screenH]);
  
  // console.log(screenH)
  function CustomToolbar() {
    return (
      <GridToolbarContainer >
        <GridToolbarQuickFilter sx={{width: 200, marginLeft: 2}} debounceMs={2000} />
        {/* <GridToolbarColumnsButton color="secondary" />
        <GridToolbarFilterButton color="secondary" /> */}
        {/* <GridToolbarDensitySelector 
          color="secondary" 
          slotProps={{ tooltip: { title: 'Change density' } }}  
          /> */}
          <Box sx={{ flexGrow: 1 }} />
          <GridToolbarExport
            slotProps={{
              tooltip: { title: 'Export data' },
              button: { variant: 'outlined' },
            }}
            className='hover:bg-slate-500 hover:cursor-pointer bg-slate-700 rounded-full m-1 ml-auto' 
          />
        {/* <GridToolbarExport color="secondary"
          printOptions={{
                    disableToolbarButton: true 
                  }} /> */}
        {/* <GridToolbarQuickFilter sx={{marginLeft: 4}}/> */}
        {((user.user.isAdmin==1 ) && 
          <Add color="secondary" className='hover:bg-slate-500 hover:cursor-pointer bg-slate-700 rounded-full m-1 ml-auto' 
            onClick={() => handleClick()}  />
        )}
      </GridToolbarContainer>
    );
  }

  function QuickSearchToolbar() {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter />
      </Box>
    );
  }
  // function CustomPagination() {
  // const apiRef = useGridApiContext();
  // const page = useGridSelector(apiRef, gridPageSelector);
  // const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  // const rowperPageOpt = [5,10,30,50,100]
  //   return (
  //     <Box sx={{ display: 'flex', alignItems: 'center' }}
  //     >
  //       <Typography sx={{mr:1, }} color="text.secondary">
  //         Rows per Page:
  //       </Typography>
  //       <Select sx={{mr:2, }}
  //           size="small"
  //           labelId="pps"
  //           id="pps"
  //           name="pps"
  //           value={pageSize}
  //           label="Rows per page"
  //           onChange={handleSelectPageSize}
  //         >
  //         {rowperPageOpt.map((opt,i) =>
  //           <MenuItem key={i} value={opt}>{opt}</MenuItem>
  //         )}
  //         </Select>
  //       <Pagination
  //         color="primary"
  //         count={pageCount}
  //         page={page + 1}
  //         onChange={(event, value) => apiRef.current.setPage(value - 1)}
  //       />
  //     </Box>
  //   );
  // }
 
  const handlePageChange =  (newPage: number) => {
    // console.log(newPage,page,pageSize);
    setPage(newPage);
  };

  const handlePageSizeChange =  (newPageSize: number) => {
    console.log(newPageSize,pageSize,page);
    setPageSize(newPageSize);
    setPage(0)
  };

  const onFilterChange = useCallback((filterModel) => {
    // console.log(filterModel);

    setFilterData({ filterModel: { ...filterModel } });
    // if (filterModel.quickFilterValues.length > 0)
    // {
    //   setFilterData(filterModel.quickFilterValues[0])
    // }
    // else {
    //   setFilterData(null)
    // }

    
  },[]);

  const handleSelectPageSize = (e) => {
    // console.log(e.target)
    setPageSize(e.target.value);
    setPage(0)
  }

  function getObjectChanges(obj1, obj2) {
    let changes = false;
    for (const key in obj1) {
      // console.log(obj1[key],obj2[key])
        if (obj1[key] !== obj2[key]) {
          // dataupdate[key] = obj2[key];
            changes = true;
        }
    }
    if(changes===true) setRowId(obj2.id);
    // console.log(changes);
    return changes;
  }    
  // !data? fetchUsers() : console.log(data);

  return (
    <>
      {user.user?.isAdmin==1 &&
    <Box className="flex flex-col w-[calc(100vw)] sm:w-[calc(100vw-160px)] mx-auto h-[calc(100vh-120px)] overflow-y-auto p-4 gap-y-4" > 
      {/* <Header title="Products Manangement" 
              subtitle="Mananging the Products" /> */}
        {/* <Box className='flex justify-center'>
        <Paper
            component="form"
            sx={{ m: '10px 4px', p: '2px', display: 'flex', width:'400px', justifyContent: 'center', alignItems: 'center', borderRadius: 2}}
        >
            
            <InputBase
                sx={{ ml: 1, flex: 1}}
                placeholder="Search data"
                inputProps={{ 'aria-label': 'search' }}
                value={searchTxt}
                onChange={(e) => setSearchTxt(e.target.value)}
            />
            <IconButton 
                type="button" 
                sx={{ p: '10px' }} 
                aria-label="search"
                color="info"
                onClick={handleSearch}
                onMouseDown={handleMouseDownSearchTxt}
            >
                <SearchIcon />
            </IconButton>
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton 
                type="button" 
                color="error" 
                sx={{ p: '10px' }} 
                aria-label="clear search text"
                onClick={handleClickClearSearchTxt}
                onMouseDown={handleMouseDownSearchTxt}
            >
                <HighlightOffOutlinedIcon  />
            </IconButton>
        </Paper>
        </Box> */}
        {/* <Box >
            <Table data={data} />
        </Box> */}

      {/* <Notistack /> */}
        {/* <Box 
            m="4px 0 0 0"
            height="80vh"

            sx={{
            "& .MuiDataGrid-root": {
              border: "solid 1px #9e9e9e",
              backgroundColor: "#5176d9",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
              color: '#112019',
              
            },
            "& .name-column--cell": {
              color: '#69f0ae',
              '&:hover': {
                backgroundColor: "#5176d9",
              },
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: '#1d1d1d',
              borderBottom: "solid 2px #0c245c",
              color: "blue",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: '#0f3b5e',
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: '#0277bd',
              color:'#ffffff',
            },
            "& .MuiCheckbox-root": {
              color: `'#69f0ae' !important`,
            },
          }}
        >
        {data && 
            <DataTable 
              title="Products Manangement" 
              subtitle="Managing the Products"
              column={columns} 
              data={data} 
              pageSize={50} 
              fieldrowID="id"
              {...{rowId, setRowId}} 
              link="/product/addnew"
            />
          }
        </Box> */}

        <Box
          m="8px 0 0 0"
          height="80vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: '#00e676',
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: '#0091ea',
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: '#5c6bc0',
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: '#0091ea',
            },
            "& .MuiCheckbox-root": {
              color: `'#69f0ae' !important`,
            },
            // "& .super-app-theme--Processing": {
            //   bgcolor: "#422e04",              
            // },
            // "& .super-app-theme--ProcessFG": {
            //   bgcolor: "#042102",              
            // },
            // "& .super-app-theme--FG": {
            //   bgcolor: "#044142",              
            // },
            // "& .super-app-theme--Onhold": {
            //   bgcolor: "#1b0329",             
            // },
            // "& .super-app-theme--Cancel": {
            //   bgcolor: "#42040a",              
            // }
          }}
        >
         <Link to="/products/addnew" 
          className="inline-block p-1 px-1 text-sm text-green-400 bg-slate-500 rounded hover:bg-teal-500"
          >
          {/* <Add color="secondary" className='hover:bg-slate-500 hover:cursor-pointer bg-slate-700 rounded-full m-1 ml-auto' 
          /> */}
            Add Product.

          </Link>
        {data && 
          <DataGrid 
            checkboxSelection={false} 
            rows={data} 
            // rowCount={rowCountState}
            columns={columns} 
            density='compact'
            // disableColumnFilter
            // disableColumnSelector
            // disableDensitySelector
            initialState={{
                columns: {
                    columnVisibilityModel: {
                        id: false,
                    },
                },
            }}
            // page={page}
            // autoPageSize
            // pageSize={pageSize}
            // rowsPerPageOptions={[5,10,30,50,100]}
            pageSizeOptions={[5, 10, 25,30, 50, 100, { value: -1, label: 'All' }]}
            // pagination
            paginationMode="client"
            // onPageChange={(newPage) => setPage(newPage)}
            // onPageChange={handlePageChange}
            // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            // onPageSizeChange={handlePageSizeChange}
            // filterMode="server"
            onFilterModelChange={onFilterChange}
            // disableSelectionOnClick
            getRowId={(row) => row.id}
            // onCellEditCommit={(params) => setRowId(params.id)}
            processRowUpdate={(updatedRow, originalRow) => {
              // console.log(updatedRow);
              // console.log(originalRow);
              getObjectChanges(originalRow, updatedRow)
              return updatedRow;
              // setRowId(params.id)
            }}
            headerHeight={38}
            slots={{ toolbar:  GridToolbarQuickFilter }}
            // slots={{ toolbar:  GridToolbar }}
            // slots={{ toolbar: QuickSearchToolbar }}
            // slotProps={{
            //   toolbar: {
            //     showQuickFilter: true,
            //     quickFilterProps: { debounceMs: 500 },
            //   },
            // }}
              // componentsProps={{
              //   toolbar: {
              //     showQuickFilter: true,
              //     quickFilterProps: { debounceMs: 1000},
              //   },
              // }}
            sx={{ 
                  // m:2,
                  [`& .${gridClasses.row}`]: {
                      bgcolor: '#f1e9e9',
                      // bgcolor: (theme) =>
                      // theme.palette.mode === 'light' ? grey[300] : grey[900],
                  },
                  [`& .${gridClasses.columnHeader}`] : {
                      bgcolor: '#0e0e7b',
                      color: '#ffffff',
                    // bgcolor: (theme) =>
                    //   theme.palette.mode === 'light' ? grey[500] : blue[800],
                  },
                  "& .MuiDataGrid-row:hover": {
                      backgroundColor: "skyblue"
                      // color: "red"
                  },
                    "& .MuiDataGrid-row.Mui-selected": {
                        bgcolor: '#0e6496',
                        color: '#ffffff',
                        '&:hover': {
                            bgcolor: '#1593c4',
                        },
                    },
                    "& .MuiSvgIcon-root": {
                        fill: "#9e9a9a",
                    },
                    "& .MuiInputBase-input.MuiInput-input": {
                        color: "#9e9a9a",
                    },
                    "& .MuiTablePagination-root": {
                        color: "#ffffff",
                    },
                    [`.${gridClasses.cell}.neg`]: {
                        backgroundColor: '#b9d5ff91',
                        color: '#ef0b0b',
                    },
                    [`.${gridClasses.cell}.pos`]: {
                    // backgroundColor: '#ff943975',
                    color: '#000000',
                    },

                  // [`& .${gridClasses.GridToolbarExport}`] : {
                  //   color: (theme) =>
                  //     theme.palette.mode === 'light' ? grey[200] : grey[700],
                  // },

              }}
              getCellClassName={(params) => {
                    if (params.field === 'instock') {
                        return params.value < 0 ? 'neg' : 'pos';;
                    }
              }}
              // getRowClassName={(params) => `super-app-theme--${params.row.status}`}
              loading={loading}
              // className="bg-gray-600 bg-gray-600"
          />
        }
      </Box>        
    </Box>
      }
      </>
  )
}

export default ProductsList